import { lazy, Suspense } from "react"

import { useNumberConvertor } from "@/hooks/useNumberConvertor"
import { useTranslation } from "@/hooks/useTranslation"
import { Fallback } from "@/molecules/Fallback"
import { LabelTabItem } from "@/molecules/LabelTabItem"
import { usePolicies } from "@/pages/GovernancePage/applications/policies/usePolicies"

const Tab = lazy(() => import("./Tab"))

import type { TabProps } from "@/pages/GovernancePage/components/pages/PoliciesPage"

export const ItemTabs = (props: TabProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.policies"
  })
  const { abbreviateNumber } = useNumberConvertor()
  // Pass props including policyCategory for CI policies
  const context = usePolicies(props)
  const count = context.response?.data?.length || 0
  const { subType } = props

  return {
    key: subType,
    label: (
      <LabelTabItem
        className="label-tab-item"
        count={abbreviateNumber(count)}
        overflowCount={999}
        title={t(subType)}
        testId={subType}
      />
    ),
    children: (
      <Suspense fallback={<Fallback />}>
        <Tab {...props} />
      </Suspense>
    )
  }
}
